var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.67 40.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#db3326;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#db3326;fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_gift") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 55.67,
    height: 38.36,
    rx: 6,
    ry: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.52,13.14a2.61,2.61,0,0,1,1.76.89s.06.08.1.12l.68.87a.58.58,0,0,0,.08.11,2.55,2.55,0,0,1,.47,1.47c2.35.06,7-.47,7.16-2.85.13-1.3-1.5-2.17-2.16-3.07-.52-.72-.8-1.59-1.34-2.31h0C21.45,4.64,18.25,10.3,17.52,13.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.59,15.66a4.22,4.22,0,0,1-3.41,1.75H16.58a4.22,4.22,0,0,1-3.37-1.69A25.67,25.67,0,0,1,5,26.37l4.73-.58-1.3,5.34a32.72,32.72,0,0,0,9-10.73,32.36,32.36,0,0,0,8.94,10.73l-1.3-5.34,4.75.58A25.65,25.65,0,0,1,21.59,15.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17,13.14a2.7,2.7,0,0,0-1.78.89s-.06.08-.08.12l-.68.87a.25.25,0,0,0-.08.11,2.59,2.59,0,0,0-.5,1.47c-2.33.06-6.93-.47-7.16-2.85-.13-1.3,1.51-2.17,2.17-3.07.54-.72.83-1.59,1.36-2.31h0C13,4.64,16.22,10.3,17,13.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.92,13.41a5,5,0,1,1,2.25,6.75A5,5,0,0,1,12.92,13.41Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.48,
    y1: 17.47,
    x2: 56.22,
    y2: 17.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.42,
    y1: 1.54,
    x2: 17.42,
    y2: 38.86
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGift);
export default __webpack_public_path__ + "static/media/icon_gift.badcc76522391a3eab85c26ae644170d.svg";
export { ForwardRef as ReactComponent };